__turbopack_context__.v({
  "className": "inter_8671c7db-module__QKqCeq__className",
  "variable": "inter_8671c7db-module__QKqCeq__variable",
});
